<template>
    <ul
        class="house-grid broker"
        v-if="result && result.listings && result.listings.length > 0"
    >
        <template v-for="(item, index) in result.listings">
            <house
                v-if="index === 3"
                :key="item.detailLink"
                :house="item"
                :showCheckbox="showCheckbox"
                @mouseenter="onMouseEnter(item.id)"
                @mouseleave="onMouseLeave(item.id)"
                @checked="onChecked(item.id)"
                v-lazy="{ callback: handleScroll }"
            />
            <house
                v-else
                :key="item.detailLink"
                :house="item"
                :showCheckbox="showCheckbox"
                @mouseenter="onMouseEnter(item.id)"
                @mouseleave="onMouseLeave(item.id)"
                @checked="onChecked(item.id)"
            />
        </template>
        <i
            v-show="showGotoTop"
            @click="handleGotoTop"
            class="btn-goto-top iconfont icon-arrow-up"
        ></i>
    </ul>
</template>

<script>
import Core from '../list';
import house from './house.vue';
export default {
    mixins: [Core],
    components: {
        house
    }
};
</script>

<style lang="scss">
.house-grid.broker {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: -20px;
    width: calc(100% + 20px);
    position: relative;
    margin-left: -20px;
    @media (max-width: 600px) {
        margin-top: -15px;
    }
    .house-grid-item {
        width: calc(33.3% - 20px);
        margin: 20px 0px 0px 0;
        margin-left: 20px;
        @media (max-width: 999px) {
            width: calc(50% - 20px);
        }
        @media (max-width: 600px) {
            margin-top: 15px;
            margin-bottom: 0px;
            width: 100%;
        }
    }
    &.full-screen {
        margin-left: -20px;
        .house-grid-item {
            margin-left: 20px;
            width: calc((100% - 20px * 4) / 4);
            @media (max-width: 1319px) {
                width: calc((100% - 20px * 3) / 3);
            }
            @media (max-width: 999px) {
                width: calc((100% - 20px * 2) / 2);
            }
            @media (max-width: 600px) {
                width: calc((100% - 20px * 1) / 1);
            }
        }
    }
    &.small {
        padding: 0 50px;
        margin-left: -20px;
        .house-grid-item {
            width: calc((100% - 40px) / 2);
            margin-left: 20px;
        }
    }
    .btn-goto-top {
        position: fixed;
        top: 50%;
        right: 10px;
        height: 40px;
        width: 40px;
        margin: 0;
        border: 1px solid #ebecf1;
        background-color: #fff;
        padding: 0;
        text-align: center;
        line-height: 38px;
        opacity: 0.95;
        border-radius: 2px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
        z-index: calc(var(--level-low) + 11);
    }
}
</style>
